import { atom } from 'recoil';

export const moduleFinishedAtom = atom({
  key: 'moduleFinished',
  default: false,
});
